import { HTMLAttributes } from 'react';
import { useGetLocale } from '../../global/LocaleProvider';

export interface NumberTextProps extends HTMLAttributes<HTMLSpanElement> {
  value: number;
  options?: Intl.NumberFormatOptions;
}

export const NumberText = ({
  value,
  options,
  className,
  style,
  ...restProps
}: NumberTextProps) => {
  const locale = useGetLocale();

  if (value == null) {
    return null;
  }

  return <span {...restProps}>{value.toLocaleString(locale, options)}</span>;
};
